/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * Inline b-roll videos: start playing when they approach the viewport
 * instead of all at once on load, so below-the-fold video bytes aren't
 * fetched until they're about to be seen.
 */
export function initInlineVideos() {
  const videos = Array.from(document.querySelectorAll('.inlineVideo .inlineVideo__bRoll'));
  if (!videos.length) return;

  const start = (video) => {
    if (video.dataset.started) return;
    video.dataset.started = '1';
    if (video.preload === 'none') video.preload = 'auto';
    const p = video.play();
    if (p && p.catch) p.catch(() => {});
  };

  if (!('IntersectionObserver' in window)) {
    videos.forEach(start);
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        start(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: '100% 0px' }); // one viewport ahead, so it's playing by the time it's visible
    videos.forEach(v => io.observe(v));
  }

  // ESC pauses any playing b-roll
  document.addEventListener('keydown', (evt) => {
    if (evt.key !== 'Escape') return;
    videos.forEach(v => { if (!v.paused) v.pause(); });
  });
}

